import React from "react";

export interface PillButtonProps {
  title: string;
  color?: string;
  action: () => void;
}

const PillButton: React.FC<PillButtonProps> = ({ title, color, action }) => {
  return (
    <button
      className={
        "btn rounded-[100px] btn-ghost w-auto h-16 px-6 py-2 " +
        color +
        " text-accent self-center mt-2 shadow-lg"
      }
      onClick={action}
    >
      <p>{title}</p>
    </button>
  );
};

export default PillButton;
